<template>

  <div class="home">
  
    <van-row class="payment">
      <van-col span="24">
        <van-divider :style="{ color: '#ffffff', borderColor: '#ffffff', padding: '0 10px' }">
          集团
        </van-divider>
        <van-grid :column-num="4">
          <van-grid-item icon="shopping-cart-o" text="采购付款" :to="{name:'Purchase',query:{classify:'1'}}"/>
          <van-grid-item icon="cashier-o" text="行政费用" :to="{name:'Administrative',query:{classify:'1'}}"/>
          <van-grid-item icon="cash-on-deliver" text="员工借款" :to="{name:'Debit',query:{classify:'1'}}"/>
          <van-grid-item icon="cash-on-deliver" text="还款" :to="{name:'PayBack',query:{classify:'1'}}"/>
          
          
          <van-grid-item icon="cash-on-deliver" text="发票报销（冲账，不付款）" :to="{name:'Invoice',query:{classify:'1'}}"/>
          <van-grid-item icon="wap-home-o" text="装修设备房租维修"  :to="{name:'Rent',query:{classify:'1'}}"/>
          <van-grid-item icon="balance-o" text="工资薪酬"  :to="{name:'Salary',query:{classify:'1'}}"/>
          <van-grid-item icon="after-sale" text="融资类支付" :to="{name:'Finance',query:{classify:'1'}}"/>

          <van-grid-item icon="after-sale" text="税金" :to="{name:'Tax',query:{classify:'1'}}"/>
          <van-grid-item icon="refund-o" text="资金调拨"  :to="{name:'Transfer',query:{classify:'1'}}"/>
          <!-- <van-grid-item  icon="cash-on-deliver" text="其它款项支付" /> -->
          <!-- <van-grid-item  icon="bill-o" text="自由流程" :to="{name:'Free',query:{classify:'1'}}"/> -->
          <van-grid-item  />
          <van-grid-item  />
        </van-grid>
        

      </van-col>
      <van-col span="24">
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 10px' }">
          分公司
        </van-divider>
        <van-grid :column-num="4">
          <van-grid-item icon="shopping-cart-o" text="采购付款" :to="{name:'Purchase',query:{classify:'2'}}"/>
          <van-grid-item icon="cashier-o" text="行政费用" :to="{name:'Administrative',query:{classify:'2'}}"/>
          <van-grid-item icon="cash-on-deliver" text="员工借款"  :to="{name:'Debit',query:{classify:'2'}}"/>
          <van-grid-item icon="cash-on-deliver" text="还款" :to="{name:'PayBack',query:{classify:'2'}}"/>
          
          <van-grid-item icon="cash-on-deliver" text="发票报销（冲账，不付款）"  :to="{name:'Invoice',query:{classify:'2'}}"/>
          <van-grid-item icon="bullhorn-o" text="营销（企划、市场）" :to="{name:'MarketOffline',query:{classify:'2'}}"/>
          <van-grid-item icon="bullhorn-o" text="营销（网络费用）"  :to="{name:'MarketOnline',query:{classify:'2'}}"/>
          <van-grid-item icon="bullhorn-o" text="营销（牙防）"  :to="{name:'Yafang',query:{classify:'2'}}"/>
          <van-grid-item icon="wap-home-o" text="装修设备房租维修"  :to="{name:'Rent',query:{classify:'2'}}"/>
          
          <van-grid-item icon="balance-o" text="工资薪酬"  :to="{name:'Salary',query:{classify:'2'}}"/>

          <van-grid-item  icon="refund-o" text="退款返现" :to="{name:'Refund',query:{classify:'2'}}"/>
          <!-- <van-grid-item  icon="bill-o" text="自由流程" :to="{name:'Free',query:{classify:'2'}}"/> -->
          <van-grid-item  />
          <van-grid-item  />
        </van-grid>
        

      </van-col>
      <!-- <van-col span="24">
        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 10px' }">
          新机构
        </van-divider>
        <van-grid :column-num="4">
          <van-grid-item icon="shopping-cart-o" text="采购付款" :to="{name:'Purchase',query:{classify:'3'}}"/>
          <van-grid-item icon="cashier-o" text="行政费用" :to="{name:'Administrative',query:{classify:'3'}}"/>
          <van-grid-item icon="cash-on-deliver" text="员工借款"  :to="{name:'Debit',query:{classify:'3'}}"/>
          <van-grid-item icon="cash-on-deliver" text="还款" :to="{name:'PayBack',query:{classify:'3'}}"/>
          
          <van-grid-item icon="cash-on-deliver" text="发票报销（冲账，不付款）"  :to="{name:'Invoice',query:{classify:'3'}}"/>
          <van-grid-item icon="bullhorn-o" text="营销（企划、市场）" :to="{name:'MarketOffline',query:{classify:'3'}}"/>
          <van-grid-item icon="bullhorn-o" text="营销（网络费用）"  :to="{name:'MarketOnline',query:{classify:'3'}}"/>
          <van-grid-item icon="wap-home-o" text="装修设备房租维修"  :to="{name:'Rent',query:{classify:'3'}}"/>
          <van-grid-item icon="balance-o" text="工资薪酬"  :to="{name:'Salary',query:{classify:'3'}}"/>
          <van-grid-item  />
          <van-grid-item  />
          <van-grid-item  />
        </van-grid>
        

      </van-col> -->
    </van-row>
    <!-- <van-row class="payment">
      
    </van-row> -->

    <Footer active="Home"></Footer>   
  </div>

  
  

</template>

<script>
// @ is an alias to /src
import Footer from './Footer.vue'

export default {
  name: 'Home',
  components: {
    Footer
  },
  data(){
    return{
      code:'',
      local:window.location.href,
      access_token:'',
      user_info:{},


    }
  },
  created(){
    // this.getCode();
    // console.log(this.$route.query)
    document.title = 'KEEN'
    // this.getCode();
    this.hasCookies();

  },
  methods:{
    hasCookies(){
      if(!this.$cookies.isKey('token')){
        this.$router.push({name:'Login'});
      }

    },
    // getCode(){
    //   this.code=this.$route.query.code;
    //   //var code = getUrlParam('code');// 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
    //   console.log(this.code);
    //   if (this.code == null || this.code == ''||this.code == "undefined") {
    //     console.log(3)
    //     //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+APPID+'&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
    //     window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwc4c076f1a1d9ecb4&redirect_uri='+encodeURIComponent(this.local)+'&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
    //     return false;
    //   } else {
    //     this.getToken(); //把code传给后台获取用户信息
    //     return false;
    //   }
    // },
    // getToken(){
    //   this.$http.post('get_token',{'code':this.code})
    //   .then((res)=>{
    //     console.log(res)
    //     localStorage.token=res.data.data.token;
    //   })

    // },
    // getAccessToken(){
    //   this.$http.post('https://admin.aomengqixiao.com/getaccesstoken')
    //   .then((res)=>{
    //     console.log(res)
    //     console.log(this.access_token)
    //     this.access_token = res.data.access_token
    //     this.approve.access_token = res.data.access_token
        
    //     this.getUserInfo();
    //   })

    // },
    // getUserInfo(){
    //   this.$http.post('https://admin.aomengqixiao.com/getuserinfo',{'access_token':this.access_token,'code':this.code})
    //   // this.$http.get('https://qyapi.weixin.qq.com/cgi-bin/user/getuserinfo?access_token='+this.access_token+'&code='+this.code)
    //   .then((res)=>{
    //     console.log(res)
    //     this.user_info = res.data
    //     this.approve.creator_userid= res.data.UserId
    //   })


    // },


  }
}
</script>
<style scoped>

.home{
  
  background:  url(/images/home_bg.jpg) repeat-x ;
  

}
.payment{
  margin:0px 10px 100px 10px;
  padding-top:10px;
}
</style>
<style>
.van-cell__title{
  font-size:1.2em;
  font-family:"Microsoft YaHei";
}
.van-cell__value{
  font-size:1.1em;
  font-family:"Microsoft YaHei";
}

</style>
